<template>
  <button
      class="base-button"
      :class="[variantClass, { 'base-button--small': small, 'base-button--block': block, 'base-button--no-margin': noMargin }]"
      :disabled="disabled"
      @click="$emit('click', $event)"
      :type="type"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "CommonButton",
  emits: ['click'],
  props: {
    variant: {
      type: String,
      default: "green",
      validator: (value) =>
          ["green", "green-outline", "blue", "gray"].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
      validator: (value) => ["button", "submit", "reset"].includes(value),
    },
    small: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variantClass() {
      return `base-button--${this.variant}`;
    },
  },
};
</script>

<style scoped lang="scss">
.base-button {
  display: inline-block;
  min-width: 125px;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  margin: 0.2rem;

  &--small {
    min-width: auto;
    padding: 0.25rem 0.5rem;
    font-size: 0.8125rem;
    margin: 0;
  }

  &--block {
    width: 100%;
  }

  &--no-margin {
    margin: 0;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &--green {
    background-color: var(--primary-green-color);
    color: white;

    &:hover:not(:disabled) {
      background-color: var(--primary-green-color-hover);
      border-color: var(--primary-green-color-hover);
    }
  }

  &--green-outline {
    background-color: transparent;
    color: var(--green-color);
    border-color: var(--green-color);

    &:hover:not(:disabled) {
      background-color: var(--primary-green-color-active);
      color: white;
      border-color: var(--primary-green-color-active);
    }
  }

  &--blue  {
    background-color: var(--primary-blue-color);
    color: white;
    &:hover {
      background-color: var(--primary-blue-color-hover);
      text-decoration: none;
    }
  }
  &--gray {
    background-color: var(--font-secondary-gray-color);
    color: white;
    &:hover {
      background-color: var(--main-background-color);
      text-decoration: none;
    }
  }


}
</style>